<template>
  <v-dialog
    v-model="dialog"
    :max-width="isMobile ? 'calc(100% - 24px)' : '650px'"
    persistent
    :content-class="isMobile ? 'qr-intro-dialog_mobile' : 'transparent-dialog'"
    @keydown.esc="closeModal"
  >
    <!-- ==================== MOBILE VIEW (< 748px) ==================== -->
    <div v-if="isMobile" class="dialog-wrapper_mobile" :style="cssVars">
      <div class="custom-modal_mobile">
        <!-- Decorative glow -->
        <div class="modal-glow_mobile"></div>

        <!-- Close -->
        <button
          type="button"
          class="close-button_mobile"
          aria-label="Close"
          @click="closeModal"
        >
          <v-icon size="20">mdi-close</v-icon>
        </button>

        <!-- Floating Icon / Image -->
        <div class="floating-icon_mobile">
          <div class="icon-inner_mobile">
            <!-- اگر تصویر اختصاصی باشد -->
            <template v-if="resolvedImage">
              <v-badge
                v-if="pro"
                color="transparent"
                overlap
                offset-x="14"
                offset-y="8"
                class="pulse-badge_mobile"
              >
                <template #badge>
                  <v-icon color="#fff" size="8" class="glow-crown">
                    mdi-crown
                  </v-icon>
                </template>
                <v-img
                  :src="resolvedImage"
                  max-width="36"
                  max-height="36"
                  contain
                  class="floating-custom-img"
                />
              </v-badge>

              <v-img
                v-else
                :src="resolvedImage"
                max-width="36"
                max-height="36"
                contain
                class="floating-custom-img"
              />
            </template>

            <!-- اگر آیکون متریال باشد -->
            <template v-else>
              <v-badge
                v-if="pro"
                color="transparent"
                overlap
                offset-x="14"
                offset-y="8"
                class="pulse-badge_mobile"
              >
                <template #badge>
                  <v-icon color="#fff" size="8" class="glow-crown">
                    mdi-crown
                  </v-icon>
                </template>
                <v-icon size="38" color="white">{{ icon }}</v-icon>
              </v-badge>

              <v-icon v-else size="38" color="white">{{ icon }}</v-icon>
            </template>
          </div>
        </div>

        <!-- Content -->
        <div class="modal-content_mobile">
          <div class="title-section_mobile">
            <div v-if="pro" class="pro-label">PRO</div>

            <h2 class="modal-title_mobile">{{ title }}</h2>

            <div class="title-line">
              <span></span>
              <i></i>
              <span></span>
            </div>
          </div>

          <!-- Description -->
          <div class="modal-description_mobile" v-html="description"></div>

          <!-- Action -->
          <div class="modal-actions_mobile">
            <v-btn
              :color="primaryColor"
              dark
              block
              large
              rounded
              elevation="3"
              class="confirm-button_mobile"
              @click="closeModal"
            >
              <span>{{ buttonText }}</span>
              <v-icon class="button-icon_mobile" size="20">
                {{ buttonIcon }}
              </v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <!-- ==================== DESKTOP VIEW (>= 748px) ==================== -->
    <div v-else class="dialog-container" :style="cssVars">
      <div class="custom-modal">
        <!-- Close Button Desktop -->
        <button
          type="button"
          class="close-button_desktop"
          aria-label="Close"
          @click="closeModal"
        >
          <v-icon size="20">mdi-close</v-icon>
        </button>

        <!-- Floating Icon / Image -->
        <div class="floating-icon">
          <!-- اگر تصویر اختصاصی باشد -->
          <template v-if="resolvedImage">
            <v-badge
              v-if="pro"
              color="transparent"
              overlap
              offset-x="14"
              offset-y="10"
              class="pulse-badge"
            >
              <template #badge>
                <v-icon color="white" size="16" class="glow-crown">
                  mdi-crown
                </v-icon>
              </template>
              <v-img
                :src="resolvedImage"
                max-width="44"
                max-height="44"
                contain
                class="floating-custom-img"
              />
            </v-badge>

            <v-img
              v-else
              :src="resolvedImage"
              max-width="44"
              max-height="44"
              contain
              class="floating-custom-img"
            />
          </template>

          <!-- اگر آیکون متریال باشد -->
          <template v-else>
            <v-badge
              v-if="pro"
              color="transparent"
              overlap
              offset-x="14"
              offset-y="10"
              class="pulse-badge"
            >
              <template #badge>
                <v-icon color="white" size="16" class="glow-crown">
                  mdi-crown
                </v-icon>
              </template>
              <v-icon size="42" color="white">{{ icon }}</v-icon>
            </v-badge>

            <v-icon v-else size="42" color="white">{{ icon }}</v-icon>
          </template>
        </div>

        <div class="modal-content">
          <h2 class="modal-title">{{ title }}</h2>
          <div class="title-line">
            <span></span>
            <i></i>
            <span></span>
          </div>

          <div class="modal-description" v-html="description"></div>

          <div class="modal-actions mb-0">
            <v-btn
              :color="primaryColor"
              dark
              block
              large
              rounded
              elevation="3"
              @click="closeModal"
            >
              {{ buttonText }}
              <v-icon left class="ml-2">{{ buttonIcon }}</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "QrIntroModal",

  props: {
    storageKey: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "mdi-information-variant",
    },
    image: {
      type: String,
      default: null,
    },
    buttonText: {
      type: String,
      default: "متوجه شدم",
    },
    buttonIcon: {
      type: String,
      default: "mdi-check",
    },
    pro: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dialog: false,
      displayMap: {
        qreitaa: "/media/socialnetwork/icon/eitaa.webp",
        qrbale: "/media/socialnetwork/icon/bale.webp",
        qrrobika: "/media/socialnetwork/icon/robika.webp",
        "qr.eitaa": "/media/socialnetwork/icon/eitaa.webp",
        "qr.bale": "/media/socialnetwork/icon/bale.webp",
        "qr.robika": "/media/socialnetwork/icon/robika.webp",
      },
      categoryColorMap: {
        "qr.cardVisit": ["#FF8008", "#FFC837", "#FF8008"],
        "qr.cardVisitPro": ["#F85D3E", "#BC9942", "#88B92D"],
        "qr.socialMedia": ["#1E6F5C", "#29BB89", "#289672"],
        "qr.photo": ["#27374D", "#9DB2BF", "#526D82"],
        "qr.video": ["#EE91E9", "#8ED2C7", "#EE98E9"],
        "qr.link": ["#410445", "#EAE4D5", "#D76C82"],
        "qr.linkPro": ["#453404", "#EAE4D5", "#C9D76C"],
        "qr.voice": ["#2B0F0F", "#2c3e50", "#593333"],
        "qr.voicePro": ["#610C9F", "#DA0C81", "#940B92"],
        "qr.feedback": ["#EB5A3C", "#FFCDB2", "#E5989B"],
        "qr.consultationQr": ["#A87676", "#E1ACAC", "#CA8787"],
        "qr.application": ["#000000", "#253900", "#08CB00"],
        "qr.luckWheel": ["#A72703", "#FCB53B", "#FFE797"],
        "qr.pdf": ["#93291E", "#ED213A", "#93291E"],
        "qr.gift": ["#8A151B", "#E3242B", "#99592A"],
        "qr.schedule": ["#2c3e50", "#2980b9", "#2c3e50"],
        "qr.Qrtext": ["#0b132b", "#1c3d5a", "#06b6d4"],
        "qr.goldLabel": ["#FFB300", "#FFCA28", "#FFF8E1"],
        "qr.business": ["#FF9800", "#FFB300", "#FFE082"],
        "qr.commercial": ["#607D8B", "#90A4AE", "#CFD8DC"],
        "qr.clickyarSeo": ["#00B0FF", "#40C4FF", "#B3E5FC"],
        "qr.labelProduct": ["#009688", "#4DB6AC", "#B2DFDB"],
        "qr.bShop": ["#F44336", "#E57373", "#FFCDD2"],
        "qr.singleProduct": ["#795548", "#A1887F", "#D7CCC8"],
        "qr.productPro": ["#1976D2", "#42A5F5", "#BBDEFB"],
        "qr.menu": ["#00BCD4", "#4DD0E1", "#B2EBF2"],
        "qr.catalog": ["#5D4037", "#8D6E63", "#D7CCC8"],
        "qr.multiCard": ["#455A64", "#78909C", "#CFD8DC"],
        "qr.instagram": ["#E4405F", "#F77737", "#FCAF45"],
        "qr.insurance": ["#2196F3", "#64B5F6", "#BBDEFB"],
        "qr.eitaa": ["#B84C24", "#fa8945", "#F05E28"],
        "qr.bale": ["#4CD6AE", "#3D9196", "#324A7D"],
        "qr.robika": ["#7c25c7", "#E45153", "#F4AA32"],
        "qr.bankcards": ["#2C296F", "#2157EE", "#F4AA32"],
        "qr.attendance": ["#0284C7", "#10B981", "#D1FAE5"],     

      },
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 748;
    },

    resolvedImage() {
      if (this.image) return this.image;
      if (
        this.icon &&
        (this.icon.startsWith("/") ||
          this.icon.startsWith("http") ||
          this.icon.includes(".png") ||
          this.icon.includes(".svg"))
      ) {
        return this.icon;
      }
      const currentRoute = this.$route.name;
      if (currentRoute && this.displayMap[currentRoute]) {
        return this.displayMap[currentRoute];
      }
      if (this.icon && this.displayMap[this.icon]) {
        return this.displayMap[this.icon];
      }
      return null;
    },

    currentColors() {
      const currentRoute = this.$route.name;
      return (
        this.categoryColorMap[currentRoute] || [
          "#f57c00",
          "#ffb74d",
          "#f57c00",
        ]
      );
    },

    primaryColor() {
      return this.currentColors[0];
    },

    cssVars() {
      const colors = this.currentColors;
      return {
        "--theme-color-primary": colors[0],
        "--theme-color-secondary": colors[1],
        "--theme-color-third": colors[2],
        "--theme-bg-gradient": `linear-gradient(135deg, ${colors[0]}, ${colors[1]})`,
      };
    },
  },

  mounted() {
    this.checkIntro();
  },

  methods: {
    checkIntro() {
      const hasSeenIntro = localStorage.getItem(this.storageKey);
      if (!hasSeenIntro) {
        this.dialog = true;
      }
    },

    closeModal() {
      this.dialog = false;
      localStorage.setItem(this.storageKey, "true");
      this.$emit("closed");
    },
  },
};
</script>

<style scoped>
/* =========================================================
   COMMON / SHARED STYLES
========================================================= */
.glow-crown {
  filter: drop-shadow(0 0 5px rgba(255, 215, 80, 0.9));
}

.floating-custom-img {
  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.25));
}

@media (max-width: 380px) {
  ::v-deep .floating-icon_mobile .v-icon.v-icon {
    font-size: 17px !important;
  }
}

@keyframes iconPulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

/* =========================================================
   DESKTOP STYLES (>= 748px)
========================================================= */
.dialog-container {
  padding: 30px 40px 40px 50px;
  background: transparent;
  box-shadow: none;
}

::v-deep .transparent-dialog {
  background: transparent !important;
  box-shadow: none !important;
  overflow: visible !important;
}

.custom-modal {
  position: relative;
  background: var(--theme-bg-gradient);
  border-radius: 55px 0 55px 0;
  padding: 55px 30px 55px 30px;
  min-height: 250px;
  display: flex;
  flex-direction: column;
  z-index: 1;
}

.custom-modal::before {
  content: "";
  position: absolute;
  top: 25px;
  bottom: 25px;
  right: 25px;
  left: -15px;
  background: #ffffff;
  border-radius: 55px 0 55px 0;
  padding-left: 13px !important;
  padding-right: 13px !important;
  z-index: -1;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.close-button_desktop {
  position: absolute;
  top: 38px;
  right: 38px;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #777;
  cursor: pointer;
  z-index: 10;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}

.close-button_desktop:hover {
  background: #eeeeee;
  color: #333;
  transform: rotate(90deg);
}

.floating-icon {
  position: absolute;
  top: 64px;
  left: -40px;
  width: 84px;
  height: 84px;
  background: var(--theme-bg-gradient);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  border-left: 2px solid rgb(255, 255, 255);
  z-index: 2;
}

.pulse-badge {
  animation: iconPulse 2.4s infinite;
}

.modal-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding-right: 29px !important;
}

.modal-title {
  color: var(--theme-color-primary);
  font-size: 1.4rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 50px;
}

.modal-description {
  color: #555555;
  text-align: right;
  font-size: 0.95rem;
  line-height: 2;
  flex-grow: 1;
  margin-bottom: 35px;
}

.modal-actions {
  margin-top: 0px;
  padding: 0px;
}

/* =========================================================
   MOBILE STYLES (< 748px)
========================================================= */
::v-deep .qr-intro-dialog_mobile {
  background: transparent !important;
  box-shadow: none !important;
  overflow: visible !important;
  max-height: 100vh !important;
  margin: 12px !important;
}

.dialog-wrapper_mobile {
  width: 100%;
  max-width: 650px;
  margin: auto;
  padding: 30px 20px 30px 55px;
  box-sizing: border-box;
}

.custom-modal_mobile {
  position: relative;
  width: 100%;
  background: #ffffff;
  border-radius: 30px;
  overflow: hidden;
  box-shadow:
    0 25px 60px rgba(0, 0, 0, 0.2),
    0 8px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.04);
  isolation: isolate;
}

.custom-modal_mobile::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 8px;
  background: var(--theme-bg-gradient);
  z-index: 3;
}

.modal-glow_mobile {
  position: absolute;
  width: 180px;
  height: 180px;
  top: -100px;
  right: -80px;
  border-radius: 50%;
  background: var(--theme-bg-gradient);
  opacity: 0.07;
  pointer-events: none;
}

.close-button_mobile {
  position: absolute;
  top: 18px;
  right: 18px;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #777;
  cursor: pointer;
  z-index: 10;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}

.close-button_mobile:hover {
  background: #eeeeee;
  color: #333;
  transform: rotate(90deg);
}

.floating-icon_mobile {
  position: absolute;
  top: 48px;
  left: -42px;
  width: 84px;
  height: 84px;
  border-radius: 50%;
  background: var(--theme-bg-gradient);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);
  z-index: 5;
  border: 4px solid #ffffff;
}

.icon-inner_mobile {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pulse-badge_mobile {
  animation: iconPulse 2.4s infinite;
}

.modal-content_mobile {
  position: relative;
  z-index: 2;
  padding: 42px 35px 30px 45px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.title-section_mobile {
  text-align: center;
  padding: 0 25px;
}

.modal-title_mobile {
  margin: 0;
  color: var(--theme-color-primary);
  font-size: 1.45rem;
  line-height: 1.5;
  font-weight: 800;
  word-break: break-word;
}

.pro-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 7px;
  padding: 3px 10px;
  border-radius: 20px;
  background: var(--theme-bg-gradient);
  color: #ffffff;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.title-line {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 12px;
  margin-bottom: 20px;
}

.title-line span {
  width: 30px;
  height: 2px;
  border-radius: 10px;
  background: var(--theme-color-primary);
  opacity: 0.25;
}

.title-line i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--theme-color-primary);
  opacity: 0.7;
}

.modal-description_mobile {
  color: #555;
  text-align: right;
  font-size: 0.95rem;
  line-height: 2;
  direction: rtl;
  max-height: 42vh;
  overflow-y: auto;
  padding: 0 5px 0 8px;
  margin-bottom: 25px;
  scrollbar-width: thin;
}

.modal-description_mobile::-webkit-scrollbar {
  width: 4px;
}

.modal-description_mobile::-webkit-scrollbar-track {
  background: transparent;
}

.modal-description_mobile::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 20px;
}

.modal-actions_mobile {
  width: 100%;
  margin-top: auto;
  padding-top: 5px;
}

.confirm-button_mobile {
  height: 50px !important;
  min-height: 50px !important;
  font-size: 0.95rem !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
  box-shadow: 0 7px 18px rgba(0, 0, 0, 0.16) !important;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease !important;
}

.confirm-button_mobile:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2) !important;
}

.button-icon_mobile {
  margin-right: 8px;
  margin-left: 0 !important;
}

/* ----------------- Sub-breakpoints for Mobile (< 748px) ----------------- */
@media (max-width: 700px) {
  ::v-deep .qr-intro-dialog_mobile {
    margin: 10px !important;
  }

  .dialog-wrapper_mobile {
    padding: 25px 15px 25px 38px;
  }

  .custom-modal_mobile {
    border-radius: 26px;
  }

  .floating-icon_mobile {
    width: 72px;
    height: 72px;
    left: -36px;
    top: 45px;
  }

  .modal-content_mobile {
    padding: 38px 25px 25px 38px;
  }

  .modal-description_mobile {
    max-height: 45vh;
  }
}

@media (max-width: 600px) {
  ::v-deep .qr-intro-dialog_mobile {
    margin: 8px !important;
    width: calc(100% - 16px) !important;
    max-width: none !important;
  }

  .dialog-wrapper_mobile {
    width: 100%;
    max-width: none;
    padding: 38px 8px 20px 8px;
  }

  .custom-modal_mobile {
    border-radius: 24px;
    max-height: calc(100vh - 55px);
    display: flex;
    flex-direction: column;
  }

  .floating-icon_mobile {
    position: relative;
    top: auto;
    left: auto;
    width: 70px;
    height: 70px;
    flex-shrink: 0;
    margin: 8px auto 10px auto;
    border-width: 4px;
  }

  .modal-content_mobile {
    padding: 15px 18px 18px 18px;
    min-height: 0;
    overflow: hidden;
  }

  .close-button_mobile {
    top: 14px;
    right: 14px;
    width: 32px;
    height: 32px;
  }

  .title-section_mobile {
    padding: 0 5px;
  }

  .modal-title_mobile {
    font-size: 1.15rem;
    line-height: 1.65;
    padding: 0 20px;
  }

  .title-line {
    margin-top: 8px;
    margin-bottom: 12px;
  }

  .title-line span {
    width: 22px;
  }

  .modal-description_mobile {
    font-size: 0.88rem;
    line-height: 1.9;
    max-height: calc(100vh - 250px);
    overflow-y: auto;
    margin-bottom: 12px;
    padding: 0 4px 0 2px;
    -webkit-overflow-scrolling: touch;
  }

  .modal-actions_mobile {
    flex-shrink: 0;
    padding-top: 5px;
    background: #ffffff;
  }

  .confirm-button_mobile {
    height: 48px !important;
    min-height: 48px !important;
    font-size: 0.88rem !important;
    box-shadow: 0 5px 14px rgba(0, 0, 0, 0.15) !important;
  }

  .button-icon_mobile {
    font-size: 18px !important;
  }
}

@media (max-width: 380px) {
  .dialog-wrapper_mobile {
    padding-left: 5px;
    padding-right: 5px;
  }

  .custom-modal_mobile {
    max-height: calc(100vh - 35px);
    border-radius: 20px;
  }

  .modal-content_mobile {
    padding: 12px 14px 14px;
  }

  .floating-icon_mobile {
    width: 62px;
    height: 62px;
    margin-top: 8px;
    z-index: 3;
  }

  .floating-icon_mobile .v-icon {
    font-size: 32px !important;
  }

  .floating-custom-img {
    max-width: 30px !important;
    max-height: 30px !important;
  }

  .modal-title_mobile {
    font-size: 1.05rem;
    padding: 0 10px;
  }

  .modal-description_mobile {
    font-size: 0.82rem;
    line-height: 1.8;
    max-height: calc(100vh - 225px);
  }

  .confirm-button_mobile {
    height: 45px !important;
    min-height: 45px !important;
  }
}
</style>
